import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Plus3Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 1C7.7285 1 1 7.7285 1 16C1 24.2715 7.7285 31 16 31C24.2715 31 31 24.2703 31 16C31 7.72967 24.2715 1 16 1ZM16 28.6762C9.01123 28.6762 3.32377 22.9899 3.32377 16C3.32377 9.01006 9.01123 3.32377 16 3.32377C22.9888 3.32377 28.6762 9.01006 28.6762 16C28.6762 22.9899 22.9899 28.6762 16 28.6762Z"
        fill="currentColor"
      />
      <path
        d="M21.8082 14.7343H17.1606V10.0867C17.1606 9.44535 16.6412 8.9248 15.9987 8.9248C15.3562 8.9248 14.8368 9.44535 14.8368 10.0867V14.7343H10.1893C9.54672 14.7343 9.02734 15.2548 9.02734 15.8962C9.02734 16.5375 9.54672 17.0581 10.1893 17.0581H14.8368V21.7056C14.8368 22.347 15.3562 22.8675 15.9987 22.8675C16.6412 22.8675 17.1606 22.347 17.1606 21.7056V17.0581H21.8082C22.4507 17.0581 22.9701 16.5375 22.9701 15.8962C22.9701 15.2548 22.4507 14.7343 21.8082 14.7343Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
